import React from 'react';
import { ArrowLeft } from 'lucide-react';

const ConfirmationHeader = ({ onBack }) => {
  return (
    <div className="text-center space-y-4">
      {/* Back Button */}
      <div className="flex justify-start">
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          type="button"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
      </div>

      {/* Title and Subtitle */}
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-gray-900">
          Confirm Your Investment
        </h1>
        <p className="text-gray-600 text-base">
          Please review the details of your investment opportunity before submission
        </p>
      </div>
    </div>
  );
};

export default ConfirmationHeader;